// extracted by mini-css-extract-plugin
export default {"success":"payment_success__5pkIY","cancel":"payment_cancel__K3rQe"};